import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_JUEGOS = 'ALL_JUEGOS';
export const ACTIVO_JUEGOS = 'ACTIVO_JUEGOS';
export const LOADING_ALL_JUEGOS = 'LOADING_ALL_JUEGOS';
export const PARAMS_JUEGOS = 'PARAMS_JUEGOS';

const initialState = {
  all: [],
  activo: null,
  loadingAll: false,
  params: {},
};

export const juegosReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_JUEGOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_JUEGOS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_JUEGOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_JUEGOS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
